export default __webpack_public_path__ + "static/media/take.53a943c8.jpg";